import GenericRequest, { METHOD_PUT } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';

export default class SaveWorkChecksTypesRequest extends GenericRequest {

    workerId;
    constructionId;
    year;
    month;
    companyId;
    documentTypeId;
    workerCheckStateId;

    constructor(constructionId, year, month, companyId, workerId, documentTypeId, workerCheckStateId) {
        super(METHOD_PUT, ApiEndpoints.MONTLY_WORK_CHECK);

        this.constructionId = constructionId;
        this.year = year;
        this.month = month;
        this.companyId = companyId;
        this.workerId = workerId;
        this.documentTypeId = documentTypeId;
        this.workerCheckStateId = workerCheckStateId;
    }

    overrideRequest() {
        const request = {};
        if ( this.constructionId ) request.construction_id = this.constructionId;
        if ( this.year ) request.year = this.year;
        if ( this.month ) request.month = this.month;
        if ( this.companyId ) request.company_id = this.companyId;
        if ( this.workerId ) request.worker_id = this.workerId;
        if ( this.documentTypeId ) request.document_type_id = this.documentTypeId;
        if ( this.workerCheckStateId ) request.worker_check_state_id = this.workerCheckStateId;
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/ws/SaveWorkChecksTypesRequest.js